/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Phoenix | v1
 * OpenAPI spec version: 1.0.0
 */

export type TransportMode = typeof TransportMode[keyof typeof TransportMode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TransportMode = {
  Air: 'Air',
  Bus: 'Bus',
} as const;
